import http from '@/utils/request'

export const passWordLogin = (data) => http.post('user/accountLogin', data)
export const getUserLogin = (data) => http.post('user/regLogin', data)
export const getSendCode = (data) => http.post('sms/send', data)
export const getVerificationCode = (phone) => http.get('user/verifyCode', { phone })
export const userInfoDetail = (data = {}) => http.post('user/userInfo', data)
export const guestLogin = (data = {}) => http.post('user/visitorLogin', data)
export const submitProblemFeedback = (data) => http.post('index/problem_feedback', data)
